import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SocialCoordination = ({ barbecueData, onUpdate }) => {
  const [activeTab, setActiveTab] = useState('chat');
  const [newMessage, setNewMessage] = useState('');
  const [newPhoto, setNewPhoto] = useState('');
  const [newRole, setNewRole] = useState({
    participantId: '',
    role: 'helper',
    description: ''
  });

  const [chatMessages, setChatMessages] = useState([
  {
    id: 1,
    sender: 'João Silva',
    message: 'Pessoal, consegui a picanha no açougue do seu Zé! 2kg por R$ 120',
    timestamp: '2025-10-15 14:30',
    type: 'text'
  },
  {
    id: 2,
    sender: 'Maria Santos',
    message: 'Ótimo! Eu vou levar as bebidas. Já comprei 2 caixas de cerveja',
    timestamp: '2025-10-15 14:35',
    type: 'text'
  },
  {
    id: 3,
    sender: 'Pedro Costa',
    message: 'Churrasqueira já está limpa e pronta! 🔥',
    timestamp: '2025-10-15 15:00',
    type: 'text'
  }]
  );

  const [photos, setPhotos] = useState([
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1734955197945-4a5eb0f683a6",
    alt: 'Carnes preparadas na churrasqueira com temperos',
    caption: 'Carnes já temperadas!',
    author: 'João Silva',
    timestamp: '2025-10-15 16:00'
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1543335133-d3dde5629763",
    alt: 'Mesa com bebidas geladas e petiscos organizados',
    caption: 'Mesa das bebidas organizada',
    author: 'Maria Santos',
    timestamp: '2025-10-15 16:15'
  }]
  );

  const [roles, setRoles] = useState([
  {
    id: 1,
    participantName: 'João Silva',
    role: 'churrasqueiro',
    description: 'Responsável por assar as carnes',
    status: 'assigned'
  },
  {
    id: 2,
    participantName: 'Maria Santos',
    role: 'organizadora',
    description: 'Coordenar bebidas e acompanhamentos',
    status: 'assigned'
  },
  {
    id: 3,
    participantName: 'Pedro Costa',
    role: 'limpeza',
    description: 'Organizar churrasqueira e limpeza',
    status: 'assigned'
  }]
  );

  const roleTypes = [
  { value: 'churrasqueiro', label: 'Churrasqueiro', icon: 'Flame', description: 'Assar as carnes' },
  { value: 'organizadora', label: 'Organizador(a)', icon: 'Users', description: 'Coordenar o evento' },
  { value: 'compras', label: 'Compras', icon: 'ShoppingCart', description: 'Fazer as compras' },
  { value: 'limpeza', label: 'Limpeza', icon: 'Trash2', description: 'Organizar e limpar' },
  { value: 'bebidas', label: 'Bebidas', icon: 'Coffee', description: 'Cuidar das bebidas' },
  { value: 'musica', label: 'Música', icon: 'Music', description: 'Cuidar da trilha sonora' },
  { value: 'helper', label: 'Ajudante', icon: 'Hand', description: 'Ajudar em geral' }];


  const tabs = [
  { id: 'chat', label: 'Chat', icon: 'MessageCircle', description: 'Conversa do grupo' },
  { id: 'photos', label: 'Fotos', icon: 'Camera', description: 'Compartilhar momentos' },
  { id: 'roles', label: 'Funções', icon: 'Users', description: 'Organizar tarefas' },
  { id: 'integration', label: 'Integração', icon: 'Smartphone', description: 'Apps externos' }];


  const sendMessage = () => {
    if (!newMessage?.trim()) return;

    const message = {
      id: Date.now(),
      sender: 'Você',
      message: newMessage?.trim(),
      timestamp: new Date()?.toLocaleString('pt-BR'),
      type: 'text'
    };

    setChatMessages((prev) => [...prev, message]);
    setNewMessage('');
  };

  const addPhoto = () => {
    if (!newPhoto?.trim()) return;

    const photo = {
      id: Date.now(),
      url: newPhoto?.trim(),
      alt: 'Foto compartilhada do evento',
      caption: 'Nova foto do churrasco',
      author: 'Você',
      timestamp: new Date()?.toLocaleString('pt-BR')
    };

    setPhotos((prev) => [...prev, photo]);
    setNewPhoto('');
  };

  const assignRole = () => {
    if (!newRole?.participantId || !newRole?.role) return;

    const participant = barbecueData?.participants?.find((p) => p?.id === parseInt(newRole?.participantId));
    if (!participant) return;

    const role = {
      id: Date.now(),
      participantName: participant?.name,
      role: newRole?.role,
      description: newRole?.description || roleTypes?.find((r) => r?.value === newRole?.role)?.description,
      status: 'assigned'
    };

    setRoles((prev) => [...prev, role]);
    setNewRole({ participantId: '', role: 'helper', description: '' });
  };

  const removeRole = (id) => {
    setRoles((prev) => prev?.filter((r) => r?.id !== id));
  };

  const shareWhatsApp = () => {
    const message = `🔥 *Churrasco ${barbecueData?.name}* 🔥\n\n📅 Data: ${barbecueData?.date}\n⏰ Horário: ${barbecueData?.time}\n📍 Local: ${barbecueData?.location}\n\n👥 Participantes: ${barbecueData?.participants?.length}\n💰 Valor por pessoa: R$ ${barbecueData?.costs?.perPerson?.toFixed(2)}\n\nVamos que vai ser top! 🍻`;

    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/?text=${encodedMessage}`);
  };

  const generateGroupInvite = () => {
    const inviteText = `Você foi convidado para o ${barbecueData?.name}!\n\nData: ${barbecueData?.date}\nHorário: ${barbecueData?.time}\nLocal: ${barbecueData?.location}\n\nConfirme sua participação: [link]`;

    navigator.clipboard?.writeText(inviteText);
    alert('Convite copiado! Cole no WhatsApp ou onde preferir.');
  };

  const renderChatTab = () =>
  <div className="space-y-4">
      {/* Messages */}
      <div className="bg-muted/30 rounded-lg p-4 max-h-96 overflow-y-auto space-y-3">
        {chatMessages?.map((msg) =>
      <div key={msg?.id} className="flex gap-3">
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center shrink-0">
              <Icon name="User" size={16} className="text-primary" />
            </div>
            
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-medium text-foreground text-sm">{msg?.sender}</span>
                <span className="text-xs text-muted-foreground">{msg?.timestamp}</span>
              </div>
              <p className="text-sm text-foreground bg-background rounded-lg p-2 border">
                {msg?.message}
              </p>
            </div>
          </div>
      )}
      </div>
      
      {/* Send Message */}
      <div className="flex gap-2">
        <Input
        value={newMessage}
        onChange={(e) => setNewMessage(e?.target?.value)}
        placeholder="Digite sua mensagem..."
        onKeyPress={(e) => e?.key === 'Enter' && sendMessage()} />

        <Button
        onClick={sendMessage}
        disabled={!newMessage?.trim()}
        iconName="Send" />

      </div>
      
      {/* Quick Actions */}
      <div className="flex flex-wrap gap-2">
        <Button
        variant="outline"
        size="sm"
        onClick={shareWhatsApp}
        iconName="MessageCircle">

          Compartilhar no WhatsApp
        </Button>
        
        <Button
        variant="outline"
        size="sm"
        onClick={generateGroupInvite}
        iconName="UserPlus">

          Gerar Convite
        </Button>
      </div>
    </div>;


  const renderPhotosTab = () =>
  <div className="space-y-4">
      {/* Add Photo */}
      <div className="flex gap-2">
        <Input
        value={newPhoto}
        onChange={(e) => setNewPhoto(e?.target?.value)}
        placeholder="URL da foto..." />

        <Button
        onClick={addPhoto}
        disabled={!newPhoto?.trim()}
        iconName="Plus" />

      </div>
      
      {/* Photo Gallery */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {photos?.map((photo) =>
      <div key={photo?.id} className="bg-card rounded-lg border border-border overflow-hidden">
            <div className="aspect-square bg-muted flex items-center justify-center">
              <img
            src={photo?.url}
            alt={photo?.alt}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }} />

              <div className="hidden w-full h-full items-center justify-center bg-muted">
                <Icon name="Image" size={32} className="text-muted-foreground" />
              </div>
            </div>
            
            <div className="p-3">
              <p className="text-sm text-foreground mb-1">{photo?.caption}</p>
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <Icon name="User" size={10} />
                <span>{photo?.author}</span>
                <span>•</span>
                <span>{photo?.timestamp}</span>
              </div>
            </div>
          </div>
      )}
      </div>
      
      {photos?.length === 0 &&
    <div className="text-center py-8 text-muted-foreground">
          <Icon name="Camera" size={48} className="mx-auto mb-2 opacity-50" />
          <p>Nenhuma foto compartilhada ainda</p>
          <p className="text-sm">Adicione URLs de fotos para compartilhar momentos</p>
        </div>
    }
    </div>;


  const renderRolesTab = () =>
  <div className="space-y-4">
      {/* Add Role */}
      <div className="bg-muted/30 rounded-lg p-4">
        <h4 className="font-medium text-foreground mb-3">Atribuir Função</h4>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">Participante</label>
            <select
            value={newRole?.participantId}
            onChange={(e) => setNewRole((prev) => ({ ...prev, participantId: e?.target?.value }))}
            className="w-full h-10 px-3 py-2 text-sm bg-background border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring">

              <option value="">Selecionar...</option>
              {barbecueData?.participants?.map((p) =>
            <option key={p?.id} value={p?.id}>{p?.name}</option>
            )}
            </select>
          </div>
          
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">Função</label>
            <select
            value={newRole?.role}
            onChange={(e) => setNewRole((prev) => ({ ...prev, role: e?.target?.value }))}
            className="w-full h-10 px-3 py-2 text-sm bg-background border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring">

              {roleTypes?.map((role) =>
            <option key={role?.value} value={role?.value}>{role?.label}</option>
            )}
            </select>
          </div>
          
          <Input
          label="Descrição"
          value={newRole?.description}
          onChange={(e) => setNewRole((prev) => ({ ...prev, description: e?.target?.value }))}
          placeholder="Descrição da função..." />

        </div>
        
        <Button
        onClick={assignRole}
        disabled={!newRole?.participantId || !newRole?.role}
        iconName="Plus"
        size="sm">

          Atribuir Função
        </Button>
      </div>
      
      {/* Roles List */}
      <div className="space-y-2">
        <h4 className="font-medium text-foreground">Funções Atribuídas ({roles?.length})</h4>
        
        {roles?.length === 0 ?
      <div className="text-center py-8 text-muted-foreground">
            <Icon name="Users" size={48} className="mx-auto mb-2 opacity-50" />
            <p>Nenhuma função atribuída ainda</p>
            <p className="text-sm">Organize as responsabilidades de cada participante</p>
          </div> :

      <div className="grid gap-2">
            {roles?.map((role) => {
          const roleInfo = roleTypes?.find((r) => r?.value === role?.role);

          return (
            <div
              key={role?.id}
              className="bg-card rounded-lg border border-border p-3 hover:shadow-md transition-shadow">

                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                        <Icon name={roleInfo?.icon} size={16} className="text-primary" />
                      </div>
                      
                      <div>
                        <h5 className="font-medium text-foreground">{role?.participantName}</h5>
                        <div className="flex items-center gap-2">
                          <span className="text-sm font-medium text-primary">{roleInfo?.label}</span>
                          <span className="text-xs text-muted-foreground">
                            {role?.description}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => removeRole(role?.id)}
                  className="text-destructive hover:bg-destructive/10">

                      <Icon name="Trash2" size={14} />
                    </Button>
                  </div>
                </div>);

        })}
          </div>
      }
      </div>
    </div>;


  const renderIntegrationTab = () =>
  <div className="space-y-4">
      {/* WhatsApp Integration */}
      <div className="bg-card rounded-lg border border-border p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
            <Icon name="MessageCircle" size={20} className="text-green-600" />
          </div>
          <div>
            <h4 className="font-medium text-foreground">WhatsApp</h4>
            <p className="text-sm text-muted-foreground">Compartilhar informações do churrasco</p>
          </div>
        </div>
        
        <div className="flex gap-2">
          <Button
          variant="outline"
          onClick={shareWhatsApp}
          iconName="Share">

            Compartilhar Detalhes
          </Button>
          
          <Button
          variant="outline"
          onClick={() => {
            const groupLink = `https://chat.whatsapp.com/exemplo123`;
            navigator.clipboard?.writeText(groupLink);
            alert('Link do grupo copiado!');
          }}
          iconName="Link">

            Criar Grupo
          </Button>
        </div>
      </div>
      
      {/* Photo Sharing */}
      <div className="bg-card rounded-lg border border-border p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
            <Icon name="Camera" size={20} className="text-blue-600" />
          </div>
          <div>
            <h4 className="font-medium text-foreground">Compartilhamento de Fotos</h4>
            <p className="text-sm text-muted-foreground">Criar álbum colaborativo</p>
          </div>
        </div>
        
        <div className="flex gap-2">
          <Button
          variant="outline"
          onClick={() => {
            const albumLink = `https://photos.google.com/share/exemplo123`;
            navigator.clipboard?.writeText(albumLink);
            alert('Link do álbum copiado!');
          }}
          iconName="Image">

            Google Photos
          </Button>
          
          <Button
          variant="outline"
          onClick={() => {
            alert('Recurso disponível em breve!');
          }}
          iconName="Instagram">

            Instagram
          </Button>
        </div>
      </div>
      
      {/* Music Integration */}
      <div className="bg-card rounded-lg border border-border p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
            <Icon name="Music" size={20} className="text-purple-600" />
          </div>
          <div>
            <h4 className="font-medium text-foreground">Playlist Colaborativa</h4>
            <p className="text-sm text-muted-foreground">Música para o churrasco</p>
          </div>
        </div>
        
        <div className="flex gap-2">
          <Button
          variant="outline"
          onClick={() => {
            const playlistLink = `https://open.spotify.com/playlist/exemplo123`;
            navigator.clipboard?.writeText(playlistLink);
            alert('Link da playlist copiado!');
          }}
          iconName="Music">

            Spotify
          </Button>
          
          <Button
          variant="outline"
          onClick={() => {
            alert('Recurso disponível em breve!');
          }}
          iconName="Youtube">

            YouTube Music
          </Button>
        </div>
      </div>
    </div>;


  const renderTabContent = () => {
    switch (activeTab) {
      case 'chat':
        return renderChatTab();
      case 'photos':
        return renderPhotosTab();
      case 'roles':
        return renderRolesTab();
      case 'integration':
        return renderIntegrationTab();
      default:
        return renderChatTab();
    }
  };

  return (
    <div className="space-y-6">
      {/* Tabs */}
      <div className="border-b border-border">
        <div className="flex overflow-x-auto">
          {tabs?.map((tab) =>
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors border-b-2 whitespace-nowrap ${
            activeTab === tab?.id ?
            'border-primary text-primary bg-primary/5' : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'}`
            }>

              <Icon name={tab?.icon} size={16} />
              <div className="text-left">
                <div>{tab?.label}</div>
                <div className="text-xs font-caption text-muted-foreground">
                  {tab?.description}
                </div>
              </div>
            </button>
          )}
        </div>
      </div>
      
      {/* Tab Content */}
      <div>
        {renderTabContent()}
      </div>
    </div>);

};

export default SocialCoordination;